var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 56,
    viewBox: "0 0 26 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.8957 55.3853C12.6509 55.3853 12.4161 55.2881 12.243 55.115C12.0699 54.9419 11.9727 54.7071 11.9727 54.4623V41.97C11.9727 41.7251 12.0699 41.4904 12.243 41.3172C12.4161 41.1441 12.6509 41.0469 12.8957 41.0469C13.1405 41.0469 13.3753 41.1441 13.5484 41.3172C13.7216 41.4904 13.8188 41.7251 13.8188 41.97V54.4376C13.8221 54.5609 13.8007 54.6836 13.7557 54.7985C13.7108 54.9133 13.6434 55.018 13.5573 55.1063C13.4713 55.1947 13.3684 55.2649 13.2548 55.3128C13.1411 55.3607 13.0191 55.3854 12.8957 55.3853Z",
    fill: "url(#paint0_linear_7667_266391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8944 55.3853C12.6675 55.3856 12.4485 55.3023 12.279 55.1514L6.74058 50.3022C6.64967 50.2214 6.57556 50.1234 6.52249 50.014C6.46942 49.9045 6.43843 49.7857 6.43129 49.6643C6.42414 49.5428 6.44099 49.4212 6.48086 49.3063C6.52073 49.1913 6.58285 49.0854 6.66366 48.9945C6.74447 48.9036 6.8424 48.8295 6.95185 48.7764C7.06131 48.7233 7.18014 48.6923 7.30157 48.6852C7.423 48.678 7.54465 48.6949 7.65957 48.7348C7.77449 48.7746 7.88044 48.8367 7.97135 48.9176L13.5098 53.7668C13.6015 53.8457 13.6767 53.942 13.7311 54.0502C13.7854 54.1583 13.8178 54.2761 13.8264 54.3968C13.8349 54.5175 13.8195 54.6387 13.7811 54.7534C13.7426 54.8682 13.6818 54.9741 13.6021 55.0653C13.514 55.1662 13.4052 55.247 13.2831 55.3022C13.161 55.3574 13.0284 55.3857 12.8944 55.3853Z",
    fill: "url(#paint1_linear_7667_266391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8952 55.3846C12.7066 55.3863 12.522 55.3302 12.3662 55.2238C12.2105 55.1175 12.0911 54.9659 12.024 54.7896C11.957 54.6133 11.9456 54.4207 11.9913 54.2377C12.037 54.0548 12.1377 53.8902 12.2798 53.7661L17.8183 48.9169C17.9092 48.8361 18.0151 48.774 18.1301 48.7341C18.245 48.6942 18.3666 48.6774 18.4881 48.6845C18.6095 48.6917 18.7283 48.7227 18.8378 48.7757C18.9472 48.8288 19.0452 48.9029 19.126 48.9938C19.2068 49.0847 19.2689 49.1907 19.3088 49.3056C19.3486 49.4205 19.3655 49.5422 19.3584 49.6636C19.3512 49.785 19.3202 49.9039 19.2671 50.0133C19.2141 50.1228 19.14 50.2207 19.0491 50.3015L13.5106 55.1508C13.3421 55.3032 13.1224 55.3867 12.8952 55.3846ZM16.2983 37.3723H9.48598C7.02087 37.369 4.65767 36.3883 2.91457 34.6452C1.17148 32.9021 0.190775 30.5389 0.187518 28.0738V10.2277C0.185092 9.00445 0.423723 7.79274 0.889777 6.66177C1.35583 5.53081 2.04017 4.50276 2.9037 3.63638C3.76722 2.77 4.793 2.08227 5.92241 1.61248C7.05183 1.14269 8.26275 0.90006 9.48598 0.898446H16.2983C17.5207 0.896828 18.7315 1.1361 19.8614 1.60259C20.9913 2.06909 22.0182 2.75365 22.8834 3.61717C23.7487 4.4807 24.4353 5.50625 24.904 6.63523C25.3727 7.76421 25.6144 8.97449 25.6152 10.1969V28.0738C25.6144 29.2962 25.3727 30.5065 24.904 31.6355C24.4353 32.7645 23.7487 33.79 22.8834 34.6536C22.0182 35.5171 20.9913 36.2017 19.8614 36.6681C18.7315 37.1346 17.5207 37.3739 16.2983 37.3723ZM9.48598 2.7446C7.51001 2.74623 5.61543 3.5319 4.2182 4.92913C2.82098 6.32636 2.0353 8.22093 2.03367 10.1969V28.0738C2.03693 30.0493 2.82312 31.9429 4.22 33.3398C5.61687 34.7367 7.51051 35.5229 9.48598 35.5261H16.2983C17.2783 35.5278 18.249 35.3362 19.1549 34.9625C20.0608 34.5888 20.8842 34.0402 21.578 33.3481C22.2718 32.656 22.8224 31.834 23.1984 30.929C23.5743 30.024 23.7683 29.0538 23.7691 28.0738V10.2277C23.7723 9.24511 23.5814 8.27159 23.2072 7.36304C22.8331 6.45449 22.2831 5.62882 21.5889 4.93347C20.8947 4.23811 20.0699 3.68678 19.162 3.31114C18.2541 2.93551 17.2809 2.74297 16.2983 2.7446H9.48598Z",
    fill: "url(#paint2_linear_7667_266391)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8957 16.228C12.6509 16.228 12.4161 16.1308 12.243 15.9577C12.0699 15.7846 11.9727 15.5498 11.9727 15.305V10.6711C11.9727 10.4263 12.0699 10.1915 12.243 10.0184C12.4161 9.8453 12.6509 9.74805 12.8957 9.74805C13.1405 9.74805 13.3753 9.8453 13.5484 10.0184C13.7216 10.1915 13.8188 10.4263 13.8188 10.6711V15.305C13.8188 15.5498 13.7216 15.7846 13.5484 15.9577C13.3753 16.1308 13.1405 16.228 12.8957 16.228Z",
    fill: "url(#paint3_linear_7667_266391)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7667_266391",
    x1: 11.9727,
    y1: 48.2161,
    x2: 13.8191,
    y2: 48.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7667_266391",
    x1: 6.42969,
    y1: 52.0344,
    x2: 13.8287,
    y2: 52.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7667_266391",
    x1: 0.1875,
    y1: 28.1415,
    x2: 25.6152,
    y2: 28.1415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7667_266391",
    x1: 11.9727,
    y1: 12.988,
    x2: 13.8188,
    y2: 12.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.9d7c1879e4e69f019b9b7e337c3d9a6f.svg";
export { ForwardRef as ReactComponent };